var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading ? _c("Loading") : _vm._e(),
      _vm.isAuthenticated
        ? _c(
            "div",
            [
              _c("AppHeader"),
              _c(
                "section",
                { staticClass: "step-progress navbar-space no-padding" },
                [
                  _c("div", { staticClass: "container step-container" }, [
                    _c("div", { staticClass: "step-title" }, [
                      _c("h4", [
                        _vm._v(
                          "การขอ" +
                            _vm._s(_vm.reqTypeList[_vm.reqType]) +
                            " e-LG Blockchain"
                        )
                      ])
                    ])
                  ])
                ]
              ),
              _c("section", { staticClass: "personal-info-sc" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-8 col-sm-12 col-xl-9 col-xs-fix" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "additonal-info-wrapper",
                            attrs: { id: "accordion" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card card-form" },
                              [
                                _vm._m(0),
                                _c(
                                  "div",
                                  { staticClass: "card-body compact-padding" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "compact-padding" },
                                      [
                                        _c("div", { staticClass: "form-row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-md-3"
                                            },
                                            [
                                              _c(
                                                "b-form-radio",
                                                {
                                                  ref: "reqType",
                                                  attrs: { value: 1 },
                                                  model: {
                                                    value: _vm.reqType,
                                                    callback: function($$v) {
                                                      _vm.reqType = $$v
                                                    },
                                                    expression: "reqType"
                                                  }
                                                },
                                                [_vm._v("ออกหนังสือค้ำประกัน")]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-md-3"
                                            },
                                            [
                                              _c(
                                                "b-form-radio",
                                                {
                                                  ref: "reqType",
                                                  attrs: { value: 2 },
                                                  model: {
                                                    value: _vm.reqType,
                                                    callback: function($$v) {
                                                      _vm.reqType = $$v
                                                    },
                                                    expression: "reqType"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "ต่ออายุหนังสือค้ำประกัน"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-md-3"
                                            },
                                            [
                                              _c(
                                                "b-form-radio",
                                                {
                                                  ref: "reqType",
                                                  attrs: { value: 3 },
                                                  model: {
                                                    value: _vm.reqType,
                                                    callback: function($$v) {
                                                      _vm.reqType = $$v
                                                    },
                                                    expression: "reqType"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "เพิ่มวงเงินหนังสือค้ำประกัน"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-md-3"
                                            },
                                            [
                                              _c(
                                                "b-form-radio",
                                                {
                                                  ref: "reqType",
                                                  attrs: { value: 4 },
                                                  model: {
                                                    value: _vm.reqType,
                                                    callback: function($$v) {
                                                      _vm.reqType = $$v
                                                    },
                                                    expression: "reqType"
                                                  }
                                                },
                                                [_vm._v("ต่ออายุ+เพิ่มวงเงิน")]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _c(_vm.dynamicType, {
                                  tag: "component",
                                  attrs: { reqType: _vm.reqType }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _c("AppFooter")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header first-header card-expandable",
        attrs: {
          id: "headingOne",
          "data-toggle": "collapse",
          "data-target": "#collapseOne",
          "aria-expanded": "true",
          "aria-controls": "collapseOne"
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "feather-icon icon-file-plus" }),
          _c("h5", { staticClass: "mb-0" }, [
            _vm._v("ประเภทการขอออกหนังสือค้ำประกัน")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }